import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from 'vue';
import { VMoney } from 'v-money';
import { SingleInput, ShortcutValue } from '@warrenbrasil/nebraska-web';
import { currencyToNumber } from '@/modules/common/helpers/currency';
import { IShortcutValue, EShortcutType } from './types';
interface Props {
  shortcutValue?: IShortcutValue[] | null;
  hasShortcut?: boolean;
  status?: string;
  helperText?: string;
  value?: string;
}
interface EmitEvents {
  (event: 'change', data: { value: number; formatted: string }): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SingleInputMoney',
  props: {
    shortcutValue: { default: null },
    hasShortcut: { type: Boolean, default: false },
    status: { default: '' },
    helperText: { default: '' },
    value: { default: '' }
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'change', data: { value: number; formatted: string }): void;
}), expose: any, slots: any, attrs: any }) {

const { value } = __props as { shortcutValue: IShortcutValue[] | null, hasShortcut: boolean, status: string, helperText: string, value: string }



const moneyValueFormatted = ref(value);
const moneyValue = computed(() => currencyToNumber(moneyValueFormatted.value));
function handleChange(event: Event) {
  const target = event.target as HTMLInputElement;
  moneyValueFormatted.value = target.value.replace('-', '');
  emitChange();
}
function onClear() {
  moneyValueFormatted.value = '0,00';
  emitChange();
}
function shortcutClick(data: IShortcutValue) {
  const options = { minimumFractionDigits: 2 };
  const numberFormat = new Intl.NumberFormat('pt-BR', options);
  if (data.type === EShortcutType.SET) {
    moneyValueFormatted.value = numberFormat.format(data.value);
  } else {
    moneyValueFormatted.value = numberFormat.format(
      moneyValue.value + data.value
    );
  }
  emitChange();
}
function emitChange() {
  const data = {
    value: moneyValue.value,
    formatted: moneyValueFormatted.value
  };
  emit('change', data);
}
onMounted(() => {
  const textarea = document.querySelector('textarea') as HTMLElement;
  VMoney(textarea, {
    value: {
      decimal: ',',
      thousands: '.',
      prefix: '',
      precision: 2
    }
  });
});

return { __sfc: true,emit, value, moneyValueFormatted, moneyValue, handleChange, onClear, shortcutClick, emitChange, SingleInput, ShortcutValue }
}

})